// Suppress harmless third-party warnings
// This file must be imported FIRST in main.ts

const originalWarn = console.warn
console.warn = (...args: unknown[]) => {
  const msg = String(args[0] || '')
  // Suppress vuestic-devtools onMounted warning (harmless, from third-party)
  if (msg.includes('onMounted is called when there is no active component')) {
    return
  }
  originalWarn.apply(console, args)
}
